import Vue from 'vue';
import Router from 'vue-router';
import { Toast } from 'vant';
import { SKIP_AUTH } from '@/config';
import { isAuthenticated, isTokenExpired, removeToken } from '@/utils/request';
import { connectAgentSocket, disconnectAgentSocket } from '@/utils/socket';

Vue.use(Router);

const WHITE_LIST = ['/login'];

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/index',
        },
        {
            path: '/login',
            name: '登录',
            component: () => import('@/pages/Login'),
            meta: { public: true },
        },
        {
            path: '/index',
            name: '首页',
            component: () => import('@/pages/Index'),
            meta: { requiresAuth: true },
        },
        {
            path: '/ChangePassword',
            name: '修改密码',
            component: () => import('@/pages/ChangePassword.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/AddMember',
            name: '新增用户',
            component: () => import('@/pages/AddMember.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/MemberTopUp',
            name: '下级上分',
            component: () => import('@/pages/MemberTopUp.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/MemberList',
            name: '用户列表',
            component: () => import('@/pages/MemberList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/FlowList',
            name: '账户流水',
            component: () => import('@/pages/FlowList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/MemberFlowList',
            name: '成员流水',
            component: () => import('@/pages/MemberFlowList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/BetRecordList',
            name: '投注记录',
            component: () => import('@/pages/BetRecordList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/ReportList',
            name: '统计报表',
            component: () => import('@/pages/ReportList.vue'),
            meta: { requiresAuth: true },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (SKIP_AUTH) {
        if (to.path === '/login') {
            next({ path: '/index', replace: true });
            return;
        }
        next();
        return;
    }

    const authed = isAuthenticated();

    if (to.path === '/login' || to.meta.public) {
        if (authed) {
            next({ path: '/index', replace: true });
            return;
        }
        disconnectAgentSocket();
        next();
        return;
    }

    if (WHITE_LIST.includes(to.path)) {
        next();
        return;
    }

    if (!authed) {
        const message = isTokenExpired()
            ? '登录已过期，请重新登录'
            : '请先登录';
        removeToken();
        disconnectAgentSocket();
        Toast.fail(message);
        next({
            path: '/login',
            query: { redirect: to.fullPath },
            replace: true,
        });
        return;
    }

    connectAgentSocket();
    next();
});

export default router;
